var _defs, _path, _path2, _path3, _circle, _line, _line2, _line3, _line4, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew269({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.76,9.29V6.15H9.5v.37H8.1v1H9.31v.37H8.1V9.29Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.4,9.29,9.71,6.15h.35l.39,2.06c0,.21.08.43.11.65l.12-.59.49-2.12h.41L12,7.74a9.82,9.82,0,0,1,.2,1.12c0-.21.08-.44.13-.69l.4-2H13l-.71,3.14H12L11.44,6.9l-.08-.37c0,.14,0,.26-.07.37l-.55,2.39Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.55,8.06V7.69h1.1V8.86a2.39,2.39,0,0,1-.52.37,1.38,1.38,0,0,1-.56.12,1.19,1.19,0,0,1-.67-.19,1.34,1.34,0,0,1-.47-.55,2.08,2.08,0,0,1-.17-.87,2.22,2.22,0,0,1,.17-.9,1.25,1.25,0,0,1,.46-.56,1.14,1.14,0,0,1,.66-.19,1.12,1.12,0,0,1,.5.11.92.92,0,0,1,.35.3,1.31,1.31,0,0,1,.2.53l-.3.1a1.18,1.18,0,0,0-.16-.4.65.65,0,0,0-.25-.21.78.78,0,0,0-.35-.07.87.87,0,0,0-.48.14,1,1,0,0,0-.33.42,1.83,1.83,0,0,0-.12.7,1.44,1.44,0,0,0,.27,1,.83.83,0,0,0,.68.31,1.1,1.1,0,0,0,.75-.32V8.06Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 3.37,
    cy: 8.03,
    r: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 0.37,
    y1: 8.03,
    x2: 6.37,
    y2: 8.03
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 0.62,
    y1: 9.05,
    x2: 6.12,
    y2: 9.05
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 0.62,
    y1: 7,
    x2: 6.12,
    y2: 7
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 1.12,
    y1: 10.08,
    x2: 5.62,
    y2: 10.08
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 1.12,
    y1: 5.98,
    x2: 5.62,
    y2: 5.98
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew269);
export default __webpack_public_path__ + "static/media/Symbolpack_New_269.b5ce5c4c3a6cb134e706853999f91d7f.svg";
export { ForwardRef as ReactComponent };